import ResetPasswordCard from "../../components/common/cards/ResetPasswordCard";


type Props = {}

const ResetPasswordPage = (props: Props) => {
  return <ResetPasswordCard />;
};

export default ResetPasswordPage;
